import SortableList from './SortableList'

export default SortableList


// WEBPACK FOOTER //
// ./src/components/profile/SortableForm/index.js